/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPurchaseOrder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 2h10.414L22 7.586V22h-9v-2h7V9h-5V4H8v5H6zm11 3.414V7h1.586zM7 10.821l5 3.125v5.608L7 22.68l-5-3.125v-5.608zm-3 5.483v2.142l2 1.25v-2.142zm4 3.392 2-1.25v-2.142l-2 1.25zM7 15.82l2.113-1.32L7 13.18 4.887 14.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPurchaseOrder as PurchaseOrder };
